// extracted by css-extract-rspack-plugin
export default {"cls1":"Tabs-cls1_giN","cls2":"Tabs-cls2_miG Tabs-cls1_giN"};